import { Gamepad2, Gift, Globe2, Trophy, Smartphone, HeartHandshake, Server, ShieldCheck, Rocket, Sparkles, BadgeCheck, Ban, EyeOff, Award, Users, Lightbulb, Mail, BookHeart } from "lucide-react";

export const STORY = [
  ["Ihr Lieben,"],
  ["vor einiger Zeit hatten wir eine Idee."],
  ["Was wäre, wenn wir ", { hi: "unser eigenes soziales Netzwerk" }, " erschaffen?"],
  ["Einen Ort, an dem Menschen nicht nur Videos anschauen, sondern sich miteinander austauschen, Freundschaften schließen, gemeinsam spielen, Punkte sammeln und für ihre Aktivität sogar echte Geschenke erhalten können."],
  [{ hi: "Eine Plattform, die anders ist." }],
  ["Eine Community, in der nicht nur große Unternehmen profitieren, sondern auch die Menschen, die sie täglich mit Leben füllen."],
  ["Und dann ist etwas passiert, das uns unglaublich glücklich macht:"],
  ["So viele von euch haben sich angemeldet, Beiträge veröffentlicht, kommentiert, gespielt und gemeinsam Punkte gesammelt."],
  ["Aus unserer Idee ist ", { hi: "durch euch eine lebendige Community" }, " geworden."],
  [{ big: "Und wir stehen erst ganz am Anfang! ❤️" }],
];

export const VISION = [
  [Gamepad2, "Neue Spiele & Challenges", "Immer neue Möglichkeiten, gemeinsam zu spielen, Spaß zu haben und Punkte zu sammeln."],
  [Gift, "Noch mehr Geschenke", "Wir möchten unser Prämiensystem weiter ausbauen und zusätzliche Geschenke verfügbar machen."],
  [Globe2, "Ein echtes soziales Netzwerk", "Ein Ort für Beiträge, Kommentare, Freundschaften, Unterhaltung und gemeinschaftliche Aktivitäten."],
  [Trophy, "Mehr Community-Events", "Gemeinsame Wettbewerbe, besondere Aktionen, Community-Challenges und Überraschungen."],
  [Smartphone, "Eine noch bessere App", "Schnellere Ladezeiten, neue Funktionen, verbesserte Bedienung und langfristig eine noch hochwertigere App-Erfahrung."],
  [HeartHandshake, "Eine Community für alle", "Eine Plattform, die weiterhin kostenlos zugänglich bleiben und möglichst ohne störende Werbung auskommen soll."],
];

export const WHY_TEXT = [
  "Unsere Community wächst und darüber freuen wir uns riesig!",
  "Aber hinter einer solchen Plattform steckt unglaublich viel Arbeit.",
  "Neue Funktionen müssen entwickelt, bestehende Funktionen verbessert und technische Systeme dauerhaft betrieben werden.",
  "Server, Datenbanken, Sicherheit, Wartung und Weiterentwicklung verursachen laufende Kosten.",
  "Bisher finanzieren wir dieses Projekt aus eigenen Mitteln.",
  "Damit wir die Community langfristig weiterentwickeln und gleichzeitig kostenlos, möglichst werbefrei und ohne kostenpflichtige Abonnements anbieten können, freuen wir uns über eure freiwillige Unterstützung.",
  "Jeder Beitrag hilft uns dabei, unsere gemeinsame Idee weiterzuführen.",
];

export const WHY = [
  [Server, "Server & Technik", "Zuverlässiger und leistungsfähiger Betrieb."],
  [ShieldCheck, "Sicherheit & Wartung", "Schutz der Plattform und kontinuierliche Verbesserungen."],
  [Rocket, "Entwicklung", "Neue Funktionen, Spiele und technische Erweiterungen."],
  [Sparkles, "Community & Prämien", "Weiterentwicklung der Aktionen und des Prämiensystems."],
];

export const PROMISE = [
  [BadgeCheck, "Kostenlos für alle", "Unsere Community soll für alle kostenlos zugänglich bleiben."],
  [Ban, "Keine kostenpflichtigen Abonnements", "Wir möchten keine monatlichen Mitgliedsgebühren verlangen."],
  [EyeOff, "Möglichst werbefrei", "Unser Ziel ist ein Community-Erlebnis ohne störende Werbung."],
  [Gift, "Echte Geschenke durch Aktivität", "Mit gesammelten Punkten sollen Mitglieder weiterhin attraktive Prämien erhalten können."],
];

export const THANKS = [
  [Mail, "Ein besonderes Dankeschön", "Jeder Unterstützer erhält eine persönliche Dankesnachricht von uns.", "now"],
  [Award, "Projekt Unterstützer Account", "Wir schalten dich als Projekt Unterstützer frei – mit pinkem Haken im Profil und allen Premium-Extras des Unterstützer-Clubs.", "now"],
  [Users, "Unterstützer-Wand", "Alle Projekt Unterstützer erscheinen mit ihrem Community-Namen auf unserer Unterstützer-Wand – ohne Betrag. Wer nicht gezeigt werden möchte, kann das in seinem Profil ausblenden.", "now"],
  [Lightbulb, "Mitgestalten der Community", "Unterstützer können ihre Ideen und Wünsche für neue Funktionen über einen eigenen Feedback-Bereich einreichen. Eine bevorzugte Umsetzung wird nicht garantiert.", "now"],
  [Sparkles, "Exklusive Entwicklungseinblicke", "Optional erhalten Unterstützer besondere Einblicke in geplante Funktionen und kommende Entwicklungen.", "soon"],
  [BookHeart, "Teil unserer Geschichte", "Das größte Dankeschön: Du hilfst dabei, unsere Community langfristig kostenlos und für alle zugänglich zu halten.", "always"],
];

export const TRUST = [
  ["🔒", "Sicher per Banküberweisung – ohne Zwischenanbieter."],
  ["❤️", "Deine Unterstützung ist freiwillig."],
  ["🎁", "Unsere Community bleibt auch ohne Unterstützung kostenlos."],
  ["ℹ️", "Freiwillige Projektunterstützung – keine steuerlich abzugsfähige Spende, sofern keine entsprechende Gemeinnützigkeit vorliegt."],
];

export const CLOSING = [
  "Wir wissen nicht, wie groß unsere Community eines Tages sein wird.",
  "Aber wir wissen, dass wir gemeinsam mit euch etwas Besonderes erschaffen möchten.",
  "Eine Plattform, auf der Menschen Spaß haben, miteinander lachen, Freundschaften schließen und für ihre Aktivität belohnt werden.",
  "Danke, dass ihr Teil unserer Geschichte seid.",
  "Ganz egal, ob ihr uns finanziell unterstützt, aktiv mitmacht oder unsere Community weiterempfehlt.",
  "Ohne euch wäre das alles nicht möglich.",
];

export const scrollToSupport = () => document.getElementById("bank-support")?.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
